import { render } from "./Code.vue?vue&type=template&id=c773e2a4&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"

import "./Code.vue?vue&type=style&index=0&id=c773e2a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c773e2a4"

export default script